import React from 'react';

export interface TextSetting {
  htmlTag: string;
  fontSize: string;
  fontWeight: string;
  fontColor: { value: string };
  id: string;
  internal: {
    type: 'ContentfulSubComponentAnimatedTextItemSettings';
  };
}

interface TextSettingsProps {
  text: string;
  settings: TextSetting;
}

const fontWeightMap: Record<string, string> = {
  100: 'font-thin',
  200: 'font-extralight',
  300: 'font-light',
  400: 'font-normal',
  500: 'font-medium',
  600: 'font-semibold',
  700: 'font-bold',
  800: 'font-extrabold',
  900: 'font-black',
};

const fontSizeMap: Record<string, string> = {
  xs: 'md:text-xs',
  sm: 'md:text-sm',
  md: 'md:text-base',
  lg: 'md:text-lg',
  xl: 'md:text-xl',
  '2xl': 'md:text-2xl',
  '3xl': 'md:text-3xl',
  '4xl': 'md:text-4xl',
  '5xl': 'md:text-5xl',
  '6xl': 'md:text-6xl',
  sx: 'md:text-base',
  '5.0rem': 'md:text-[5rem]',
};

const TextSettings = ({
  text,
  settings,
}:TextSettingsProps) => {
  const {
    htmlTag,
    fontSize,
    fontWeight,
    fontColor,
  } = settings;

  const Tag = htmlTag as keyof JSX.IntrinsicElements;

  const fontWeightClass = fontWeightMap[fontWeight] || '';
  const fontSizeClass = fontSizeMap[fontSize] || '';

  return (
    <Tag
      className={`text-5xl ${fontSizeClass} ${fontWeightClass} mt-1 mb-1 font-poppins-bold leading-[1]`}
      style={{
        color: fontColor.value,
      }}
    >
      {text}
    </Tag>
  );
};

export default TextSettings;
